import * as actions from './actions'
import { success, failure } from 'utilities/actions'

export type State = {
  data: {
    notice?: string;
  };
  submitting: boolean;
  errors: any[];
};

type Action = {
  type: string;
  data?: any;
  errors?: any[];
};

const initialState = {
  data: {
    notice: ''
  },
  submitting: false,
  errors: []
} as const

const reducer = (state: State, action: Action) => {
// @ts-expect-error - TS2322 - Type '{ readonly data: { readonly notice: ""; }; readonly submitting: false; readonly errors: readonly []; }' is not assignable to type 'State'.
  if (state === undefined) { state = initialState }
  const { data, errors } = action
  switch (action.type) {
    case success(actions.API_DATA_EXTRACT_REQUEST_CREATE):
      return { ...state, data, submitting: false }
    case failure(actions.API_DATA_EXTRACT_REQUEST_CREATE):
      return { ...state, errors, submitting: false }
    case actions.API_DATA_EXTRACT_REQUEST_CREATE:
      return { ...state, submitting: true }
    case actions.CLEAR_NOTICE:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
